function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.049 14.029"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m13.676 5.033-4.319-.66L7.422.249a.457.457 0 0 0-.794 0L4.692 4.373l-4.319.66a.439.439 0 0 0-.248.741l3.138 3.215-.742 4.547a.439.439 0 0 0 .646.455l3.858-2.132 3.858 2.133a.439.439 0 0 0 .646-.455l-.743-4.547 3.138-3.216a.439.439 0 0 0-.248-.741z",
    style: {
      fill: "#ffc107"
    },
    transform: "translate(0 -.018)"
  }));
};
export default SvgStar;